// src/components/Footer/FooterQuery.js
import { gql } from "@apollo/client";
import { apolloClient } from "../../services/apolloclient";

export const GET_FOOTER = gql`
  query MyQuery {
    footer {
      enabled
      openinghoursTitle
      openDays
      openTimes
      linkComponent {
        contentItems {
          ... on Links {
            url {
              text
              url
            }
            enabled
          }
        }
      }
      contactusTitle
      address

      infoSectionComponent {
        contentItems {
          ... on InfoSection {
            enabled
            image {
              urls
            }
            text
          }
        }
      }

      socialIconComponent {
        contentItems {
          ... on SocialIcons {
            enabled
            image {
              urls
            }
            link {
              text
              url
            }
          }
        }
      }

      linkTitle
      copyRightText

      privacypolicyUrl {
        text
        url
      }

      termsofuseUrl {
        text
        url
      }
    }
  }
`;

export async function fetchFooter() {
  const response = await apolloClient.query({
    query: GET_FOOTER,
    fetchPolicy: "network-only",
  });

  return response.data;
}
